





























import Vue from 'vue'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import { GET_LOGGED_IN_USERS, LOG_USER_OUT_BY_TOKEN } from '@/store/action-types'
import { LoggedInUsersResponse } from '@/types/service-response'
import { LogUserOutByTokenPayload } from '@/types/payload'
import { LoggedInUser } from '@/model/settings/LoggedInUser'

interface ComponentData {
  userList: LoggedInUser[]
  licenses: number | null
  usedLicenses: number | null
  loadingIdList: number[]
}

export default Vue.extend({
  name: 'SecurityPage',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection
  },

  props: {

  },

  data (): ComponentData {
    return {
      userList: [],
      licenses: null,
      usedLicenses: null,
      loadingIdList: []
    }
  },

  watch: {

  },

  computed: {

  },

  methods: {

    onLogOutClick (item: LoggedInUser): void {
      if(item.ID && item.Token) {
        const payload: LogUserOutByTokenPayload = {
          userId: item.ID,
          token: item.Token
        }
        this.logUserOut(payload, item.position)
        this.loadingIdList.push(item.position)
      }
    },

    async logUserOut (payload: LogUserOutByTokenPayload, position: number): Promise<void> {
      try {
        const response: boolean = await this.$store.dispatch(LOG_USER_OUT_BY_TOKEN, payload)
        if(response) {
          this.loadingIdList.splice(position)
          await this.fetchData()
        } else {

        }
      } catch {

      }
    },

    async fetchData (): Promise<void> {
      try {
        const response: LoggedInUsersResponse = await this.$store.dispatch(GET_LOGGED_IN_USERS)
        if(response && !response.IsError) {
          this.userList = response.LoggedInUsers ? LoggedInUser.createFromResponse(response.LoggedInUsers) : []
          this.licenses = response.Licenses
          this.usedLicenses = response.UsedLicenses
        } else {

        }
      } catch {

      }
    }
  },

  mounted () {
    this.fetchData()
  }
})
